module.exports = __webpack_public_path__ + "media/images/icons/credit_points-46c81dcb33f42eb5c6739ce6d62b582a.svg";